<div class="comment-container" [class.child-comment]="comment.parentCommentId">
    <!-- Comment Header -->
    <div class="comment-header">
        <div
            class="user-badge"
            [class.support-badge]="comment.createdBySupport"
            [class.customer-badge]="!comment.createdBySupport"
        >
            <span class="role-indicator">
                <mat-icon *ngIf="comment.createdBySupport">support_agent</mat-icon>
                <mat-icon *ngIf="!comment.createdBySupport">person</mat-icon>
            </span>
            <span class="user-name">{{ comment.createdByName }}</span>
            <span class="timestamp">{{ comment.createdAt | date : 'dd.MM.yyyy - HH:mm' }}</span>
            <mat-icon *ngIf="myComment" (click)="editComment(comment)" matTooltip="Bearbeiten">edit</mat-icon>
        </div>
        <div class="edit-history" *ngIf="comment?.edits?.length && comment.edits.length > 1">
            <span>zuletzt bearbeitet {{ comment.editedAt | date : 'dd.MM.yyyy - HH:mm' }}</span>
            <mat-icon
                [satPopoverAnchor]="verlauf"
                (mouseenter)="verlauf.open()"
                (mouseleave)="verlauf.close()"
                matTooltip="Bearbeitungsverlauf anzeigen"
            >
                visibility
            </mat-icon>
            <sat-popover #verlauf horizontalAlign="before" verticalAlign="below">
                <div class="history-popover-content">
                    <div class="history-item" *ngFor="let edit of comment.edits">
                        <div class="history-timestamp">{{ edit.unix | date : 'dd.MM.yyyy - HH:mm' }}</div>
                        <div
                            class="history-text"
                            [innerHTML]="firebaseService.getLines(edit.text) || 'Kein Kommentar' | safehtml"
                        ></div>
                    </div>
                </div>
            </sat-popover>
        </div>
    </div>

    <!-- Comment Content -->
    <div class="comment-body" *ngIf="comment.text || comment.attachments">
        <div
            [class.parent-comment]="!comment.parentCommentId"
            [class.comment-content]="comment.parentCommentId"
            [class.support-comment]="comment.createdBySupport"
            [class.customer-comment]="!comment.createdBySupport"
        >
            <div class="comment-content-wrapper">
                <div class="comment-text" [innerHTML]="firebaseService.getLines(comment.text) | safehtml"></div>

                <div class="comment-actions">
                    <button
                        class="edit-action"
                        *ngIf="myComment"
                        (click)="editComment(comment)"
                        matTooltip="Bearbeiten"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button class="reply-action" (click)="addReply()" matTooltip="Antworten">
                        <mat-icon>reply</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Attachments -->
            <div class="attachments-section" *ngIf="comment.attachments && comment.attachments.length > 0">
                <a class="attachment-link" *ngFor="let att of comment.attachments" [href]="att" target="_blank">
                    <mat-icon>attach_file</mat-icon>
                    Anhang öffnen
                </a>
            </div>
        </div>

        <!-- Child Comments -->
        <div class="child-comments-container" *ngIf="uComments && uComments.length > 0">
            <app-comment *ngFor="let uComment of uComments" [comment]="uComment" [allComments]="allComments">
            </app-comment>
        </div>
    </div>
</div>
